import React, { useState, useEffect } from 'react';
import patientService from '../../../../../services/patient.service';
import { useEyeconxStore } from '../../../../../store/eyeconxStore';
import Loading from '../../../../common/Loading';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

function Overview({ patient }) {
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    const { register, handleSubmit, setValue } = useForm();

    // Prefill form when editing is enabled
    useEffect(() => {
        if (isEditing && patient) {
            setValue("email", patient.email || "");
            setValue("cellNumber", patient.cellNumber || "");
            setValue("phoneNumber", patient.phoneNumber || "");
            setValue("isActive", patient.isActive ? "true" : "false");
        }
    }, [isEditing, patient, setValue]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
              // Clean phone formats (digits only)
        const cleanCell = (data.cellNumber || '')
            .replace(/\D/g, ''); // remove anything not 0–9

        const cleanPhone = (data.phoneNumber || '')
            .replace(/\D/g, '');

            await patientService.updatePatient(clinicId, patient.id, {
                email: data.email,
                cellNumber: cleanCell,
                phoneNumber: cleanPhone,
                isActive: data.isActive === "true" // convert from string → boolean
            });

            setIsEditing(false);
            toast.success("Patient updated successfully");
        } catch (error) {
            console.error("Error updating patient:", error);
            toast.error(error.response?.data?.message || error.message || "Failed to update patient");
        } finally {
            setLoading(false);
        }
    };
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birth = new Date(dob);
    const diff = new Date().getFullYear() - birth.getFullYear();
    const monthDiff = new Date().getMonth() - birth.getMonth();
    return monthDiff < 0 ? diff - 1 : diff;
  };
    return (
        <>
         <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-bottom-0 py-3">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">
            <i className="bi bi-person me-2 text-primary"></i>
            Patient Information
            
          </h5>

         <div className="d-flex justify-content-end mb-2">
                {!isEditing ? (
                    <button className="btn btn-sm btn-outline-primary" onClick={() => setIsEditing(true)}>
                        <i className="bi bi-pencil me-1"></i> Edit
                    </button>
                ) : (
                    <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => setIsEditing(false)}>
                        <i className="bi bi-x-lg me-1"></i> Cancel
                    </button>
                )}
            </div>
        </div>
      </div>

      <div className="card-body">
           

            {isEditing ? (
                <>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Email</h6>
                            <input className="form-control" {...register("email")} />
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Cell Number</h6>
                            <input className="form-control" {...register("cellNumber")} />
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Phone Number</h6>
                            <input className="form-control" {...register("phoneNumber")} />
                        </div>
                    </div>

                    {/* STATUS RADIO BUTTONS */}
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Status</h6>
                            
                            <div className="form-check">
                                <input
                                    type="radio"
                                    value="true"
                                    {...register("isActive")}
                                    className="form-check-input"
                                    id="active"
                                />
                                <label className="form-check-label" htmlFor="active">Active</label>
                            </div>

                            <div className="form-check">
                                <input
                                    type="radio"
                                    value="false"
                                    {...register("isActive")}
                                    className="form-check-input"
                                    id="inactive"
                                />
                                <label className="form-check-label" htmlFor="inactive">Inactive</label>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primary text-white">
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </button>
                </form>
                 <div className="alert alert-info mt-4">
                    <i className='bi bi-info-circle'></i> Only Email, Cell Phone, Phone number and status is editable by Eyeconx.
                    </div>
                </>
            ) : (
                <>
                    {/* VIEW MODE */}
                    <div className="row">
                        <div className="col-md-6">
                            <h6 className="text-muted mb-1">First Name</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.firstName}</p>
                        </div>

                        <div className="col-md-6">
                            <h6 className="text-muted mb-1">Last Name</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.lastName}</p>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Birth Date</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.dateOfBirth}</p>
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Age</h6>
                            <p className="mb-3 bg-light p-2 rounded">{calculateAge(patient?.dateOfBirth)}</p>
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Gender</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.gender}</p>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Email</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.email}</p>
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Cell Number</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.cellNumber}</p>
                        </div>

                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Phone Number</h6>
                            <p className="mb-3 bg-light p-2 rounded">{patient?.phoneNumber}</p>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <h6 className="text-muted mb-1">Status</h6>
                            <p className="mb-3 p-2 rounded bg-light">
                                {patient?.isActive ? "Active" : "Inactive"}
                            </p>
                        </div>
                    </div>
                   
                </>
            )}
            </div>
            </div>
        </>
    );
}

export default Overview;
